import _ from 'lodash'
import React from 'react'
import {renderSelf} from 'views/Shared'
import {errorNotify} from './createNotification'
import {errorMessage} from './createMessageNotification'

// Map numeric error codes từ ErrorCode.php → human-readable label (i18n key)
const ERROR_CODE_LABELS = {
    10000: 'item not found',
    10001: 'member not found',
    10002: 'exceed limit',
    10003: 'status update not allowed',
    10004: 'invalid status',
    10005: 'item already exists',
    10006: 'cannot remove yourself',
    10007: 'item not verified',
    10008: 'user not activated',
    10009: 'invalid source',
    10010: 'invalid destination',
    10011: 'admin required',
    10013: 'no locations available',
    10014: 'username already exists',
    10017: 'owner required',
    10018: 'insufficient permissions',
    10401: 'authentication error',
    10405: 'method not allowed',
    10422: 'validation error',
    10500: 'system error',
    11404: 'page not found',
}

const humanizeField = (field) =>
    String(field).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())

const getErrors = (errors) => {
    if (errors && typeof errors === 'object') {
        const keys = Object.keys(errors)
        return (
            <ul className="mt-1 space-y-0.5 list-none p-0">
                {keys.map((name, index) => {
                    const msgs = Array.isArray(_.get(errors, name))
                        ? _.get(errors, name).join(', ')
                        : String(_.get(errors, name))
                    return (
                        <li key={index} className="text-xs leading-snug">
                            <span className="font-semibold">{humanizeField(name)}: </span>
                            <span className="opacity-90">{msgs}</span>
                        </li>
                    )
                })}
            </ul>
        )
    }
    return <span className="text-xs">{String(errors)}</span>
}

const buildErrorParams = (errorObj = {}) => {
    const {error_code, error, message} = errorObj || {}

    const codeLabel =
        typeof error_code === 'number'
            ? (ERROR_CODE_LABELS[error_code] ?? 'system error')
            : typeof error_code === 'string'
                ? error_code
                : 'system error'

    const description =
        error == null
            ? (message ?? undefined)
            : typeof error === 'string'
                ? error
                : getErrors(error)

    return {message: codeLabel, description}
}

// ── Notification (antd notification — luồng cũ) ──────────────────
const onError = (error, errorObj, translate = renderSelf) => {
    errorNotify(translate, buildErrorParams(errorObj))
}

export const notifyOnError = (translate) => (error, errorObj) =>
    onError(error, errorObj, translate)

// ── Message (antd message — luồng mới) ───────────────────────────
const onErrorMessage = (error, errorObj, translate = renderSelf) => {
    errorMessage(translate, buildErrorParams(errorObj))
}

export const messageOnError = (translate) => (error, errorObj) =>
    onErrorMessage(error, errorObj, translate)